function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.307)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.307 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.51,41.649a.79.79,0,0,0,.8-.783V8.3a.785.785,0,0,0-.233-.554L46.429.229A.813.813,0,0,0,45.866,0H14.44a2.477,2.477,0,0,0-2.495,2.453V3.34H5.1a.788.788,0,0,0-.563,1.336L10.766,10.8,4.534,16.931A.788.788,0,0,0,5.1,18.267h6.848v29.28A2.477,2.477,0,0,0,14.44,50H51.812a2.477,2.477,0,0,0,2.495-2.453v-3.34a.8.8,0,0,0-1.593,0v3.34a.9.9,0,0,1-.9.887H14.44a.9.9,0,0,1-.9-.887V18.267h5.149a.783.783,0,1,0,0-1.566H7.019l5.436-5.344a.774.774,0,0,0,0-1.107L7.019,4.906H41.672V16.7H22.084a.783.783,0,1,0,0,1.566H42.469a.79.79,0,0,0,.8-.783V4.123a.79.79,0,0,0-.8-.783H13.537V2.453a.9.9,0,0,1,.9-.887H45.07V6.628a2.477,2.477,0,0,0,2.495,2.453h5.149V40.866A.79.79,0,0,0,53.51,41.649ZM47.565,7.516a.9.9,0,0,1-.9-.887V2.673l4.926,4.843Z",
  transform: "translate(-4.307 0)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.543 7.606)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M161.62,82.224h-1.81V78.605h1.81a.823.823,0,0,0,0-1.645h-2.632a.823.823,0,0,0-.823.823v5.264a.823.823,0,0,0,.823.823h2.632a.823.823,0,0,0,0-1.645Z",
  transform: "translate(-158.165 -76.96)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.624 7.606)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M212.927,79.592h-1.81v-.987h1.81a.823.823,0,0,0,0-1.645h-2.632a.823.823,0,0,0-.823.823v2.632a.823.823,0,0,0,.823.823h1.81v.987h-1.81a.823.823,0,0,0,0,1.645h2.632a.823.823,0,0,0,.823-.823V80.415A.822.822,0,0,0,212.927,79.592Z",
  transform: "translate(-209.472 -76.96)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(29.688 7.606)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M265.369,77a.83.83,0,0,0-1.04.52l-.974,2.923-.974-2.923a.823.823,0,1,0-1.561.52l1.755,5.264a.823.823,0,0,0,1.561,0l1.755-5.264A.83.83,0,0,0,265.369,77Z",
  transform: "translate(-260.776 -76.958)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.994 19.401)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M184.432,213.779H159.865a1.7,1.7,0,0,0-1.7,1.7v22.812h0a1.7,1.7,0,0,0,1.7,1.7h24.567a1.7,1.7,0,0,0,1.7-1.7V215.479A1.7,1.7,0,0,0,184.432,213.779Zm.055,24.512a.055.055,0,0,1-.055.055H159.865a.055.055,0,0,1-.055-.055V215.479a.055.055,0,0,1,.055-.055h24.567a.055.055,0,0,1,.055.055v22.812Z",
  transform: "translate(-158.165 -213.779)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.764 25.011)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M205.252,256.534h-3.51a.823.823,0,1,0,0,1.645h3.51a.823.823,0,0,0,0-1.645Z",
  transform: "translate(-200.92 -256.534)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.363 25.011)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M280.681,256.534H270.153a.823.823,0,0,0,0,1.645h10.529a.823.823,0,1,0,0-1.645Z",
  transform: "translate(-269.33 -256.534)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.764 30.013)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M205.252,307.841h-3.51a.823.823,0,1,0,0,1.645h3.51a.823.823,0,1,0,0-1.645Z",
  transform: "translate(-200.92 -307.841)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.363 30.013)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M280.681,307.841H270.153a.823.823,0,0,0,0,1.645h10.529a.823.823,0,1,0,0-1.645Z",
  transform: "translate(-269.33 -307.841)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.764 35.016)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M205.252,359.148h-3.51a.823.823,0,1,0,0,1.645h3.51a.823.823,0,1,0,0-1.645Z",
  transform: "translate(-200.92 -359.148)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.552 35.016)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M272.785,359.148h-2.632a.823.823,0,0,0,0,1.645h2.632a.823.823,0,1,0,0-1.645Z",
  transform: "translate(-269.33 -359.148)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.764 39.734)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M205.252,410.455h-3.51a.823.823,0,0,0,0,1.645h3.51a.823.823,0,0,0,0-1.645Z",
  transform: "translate(-200.92 -410.455)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.552 39.734)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M272.785,410.455h-2.632a.823.823,0,0,0,0,1.645h2.632a.823.823,0,0,0,0-1.645Z",
  transform: "translate(-269.33 -410.455)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.436 34.804)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M333.275,362.6l1.755-2.106a.823.823,0,1,0-1.264-1.053l-1.562,1.874-1.562-1.874a.823.823,0,1,0-1.264,1.053l1.755,2.106-1.755,2.106a.823.823,0,1,0,1.264,1.053l1.562-1.874,1.562,1.874a.823.823,0,1,0,1.264-1.053Z",
  transform: "translate(-329.189 -359.146)"
})));

function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.818653ae.svg";
export { ForwardRef as ReactComponent };